// visuals.ts — shared visual helpers.
//
// Subtle ambient effects: a slow breathing animation when the room is quiet,
// a flash on each bar boundary so users feel the downbeat.

const BAR_FLASH_MS = 80;

export function flashBar(root: HTMLElement): void {
  root.classList.add("bar-flash");
  setTimeout(() => root.classList.remove("bar-flash"), BAR_FLASH_MS);
}

export function setStatus(status: "connecting" | "open" | "closed"): void {
  const el = document.getElementById("status");
  if (!el) return;
  el.textContent = ({
    connecting: "connecting…",
    open: "live",
    closed: "offline",
  })[status];
  el.dataset.state = status;
}

export function setRoomLabel(roomId: string): void {
  const el = document.getElementById("room-label");
  if (el) el.textContent = `/r/${roomId}`;
}
